module.exports = __webpack_public_path__ + "static/media/iso_logo_01.79849306.jpg";